import { Flex } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';
import { SortOrder } from '@duke-hq/lib/pagination';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import { FilterItem } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilterTypes';

interface Filters {
  orderBy?: string | undefined;
  sort?: SortOrder | undefined;
  providerIds?: string | undefined;
}

export function StudentFilters({
  filters,
  providerOptions,
  onChange,
}: {
  filters: Filters;
  providerOptions: FilterItem[];
  onChange: (newFilters: Filters) => void;
}) {
  return (
    <Flex gap={2}>
      {Array.isArray(providerOptions) && providerOptions.length > 0 ? (
        <MultipleChoiceFilter
          items={providerOptions}
          label={t`Provider`}
          name="providerIds"
          value={filters.providerIds}
          onFilterChange={onChange}
        />
      ) : null}
    </Flex>
  );
}
